import { getOrderedSetups } from "diagnostics-domain/setup/getSetup";
export function getMostRecentDisplayNames(
  setups: {
    failures: { name: string; displayName: string }[];
    id: string;
    startDate: string | Date | null;
  }[],
) {
  const orderedSetups = getOrderedSetups(setups);

  const displayNameByFailureName = orderedSetups.reduce(
    (acc, setup) => {
      for (const failure of setup.failures) {
        if (acc[failure.name]) continue;
        acc[failure.name] = failure.displayName;
      }
      return acc;
    },
    {} as Record<string, string>,
  );

  return displayNameByFailureName;
}
